"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPostbacks = exports.createOWCampaign = exports.createDirectCampaign = exports.removeGeosFromAllRedirectCampaigns = exports.addGeosToAllRedirectCampaigns = exports.prepareOWCampaignParameters = exports.TRAFFIC_SOURCE_ID_DIRECT_AI = exports.TRAFFIC_SOURCE_ID_FLASH_AI = void 0;
exports.TRAFFIC_SOURCE_ID_FLASH_AI = 22;
exports.TRAFFIC_SOURCE_ID_DIRECT_AI = 23;
let prepareOWCampaignParameters = (app) => {
    return {};
};
exports.prepareOWCampaignParameters = prepareOWCampaignParameters;
let addGeosToAllRedirectCampaigns = async (geosToAdd) => { };
exports.addGeosToAllRedirectCampaigns = addGeosToAllRedirectCampaigns;
let removeGeosFromAllRedirectCampaigns = async (geoToRemove) => { };
exports.removeGeosFromAllRedirectCampaigns = removeGeosFromAllRedirectCampaigns;
async function createDirectCampaign(app) {
    throw new Error('createDirectCampaign: not implemented');
}
exports.createDirectCampaign = createDirectCampaign;
async function createOWCampaign(app, platform) {
    throw new Error('createOWCampaign: not implemented');
}
exports.createOWCampaign = createOWCampaign;
async function sendPostbacks(subids, status, payout) { }
exports.sendPostbacks = sendPostbacks;
